<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!warehouse">
      <span class="loader"></span>
    </span>
    <div v-if="warehouse" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <warehouse-view-global
            :warehouse="warehouse"
            @warehouseUpdated="get"
          />
        </tab-pane>

        <tab-pane title="warehouse-products" id="3">
          <span slot="title">
            <i class="fa fa-cubes" />
            {{ $t("COMMON.PRODUCTS") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <warehouse-view-warehouse-products :warehouse="warehouse" />
          </div>
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="warehouse" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <warehouse-view-logs :warehouse="warehouse" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import WarehouseViewGlobal from "../partials/WarehouseViewGlobal.vue";
import WarehouseViewLogs from "../partials/WarehouseViewLogs.vue";
import WarehouseViewWarehouseProducts from "../partials/WarehouseViewWarehouseProducts.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    WarehouseViewGlobal,
    WarehouseViewLogs,
    ListFileComponent,
    WarehouseViewWarehouseProducts,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    warehouseId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      warehouse: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("warehouses/get", this.warehouseId);
        this.warehouse = this.$store.getters["warehouses/warehouse"];
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
